"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var modal_1 = require("../../components/common/modal");
var organization_edit_form_1 = require("../../components/form/organization-edit-form");
require("./organization-edit.scss");
var OrganizationEdit = function (_a) {
    var employeeView = _a.employeeView, selectedOrganizationId = _a.selectedOrganizationId, shouldShowModal = _a.shouldShowModal, setShouldShowModal = _a.setShouldShowModal;
    return (React.createElement(modal_1.default, { isOpen: shouldShowModal, onClose: function () { return setShouldShowModal(false); } },
        React.createElement(organization_edit_form_1.default, { onFinish: function () { return setShouldShowModal(false); }, employeeView: employeeView, isModal: true, selectedOrganizationId: selectedOrganizationId })));
};
exports.default = OrganizationEdit;
//# sourceMappingURL=organization-edit.js.map